import { bind, SUSPENSE } from "@react-rxjs/core"
import { map } from "rxjs"

import type { BarResponse } from "@/App/Equities/shared/services/TradingGateway"

import { historicalBars$ } from "./historicalBars"

type HighchartsOHLC = {
  x: number
  open: number
  high: number
  low: number
  close: number
}

export const [useOhlcChartData, ohlcChartData$] = bind<
  HighchartsOHLC[] | typeof SUSPENSE
>(
  historicalBars$.pipe(
    map((bars) => {
      if (bars === SUSPENSE) return SUSPENSE
      return bars.map(
        (bar: BarResponse) =>
          ({
            x: new Date(bar.t).getTime(),
            open: Number(bar.o),
            high: Number(bar.h),
            low: Number(bar.l),
            close: Number(bar.c),
          }) satisfies HighchartsOHLC,
      )
    }),
  ),
)
